import React, { Component } from "react";
import BaseConfig from "../../../components/BaseConfig/index";

import api from "../../../services/api";
import * as Permissions from "../../../services/permissions";
import { Spin, Table, Button, Alert, Switch, notification } from "antd";



export default class DadosPlecto extends React.Component {

    state = {
        loading: false,
        dados: { enviar_dados: false }
    }

    componentDidMount = async () => {
        this.setState({
            loading: true
        })
        let res = await api.get('/dados_plecto/')
        console.log(res.data[0])
        this.setState({
            loading: false,
            dados: res.data[0]
        })
    }

    handleOnChange = async (checked) => {
        try {
            let res = await api.put(`/dados_plecto/${this.state.dados.id}/`, { enviar_dados: checked })
            notification.open({
                message: "Sincronização alterada com sucesso"
            })
        } catch (err) {
            notification.open({
                message: "Ocorreu um erro"
            })
        }

    }


    render() {
        return (
            <BaseConfig
                title="Integração com o Plecto"
                subtitle="Gerencie a integração com plecto"
            >
                <div style={{ padding: "15px", textAlign: "left" }}>
                    {this.state.loading ? (
                        <Spin />
                    ) : (
                            <div>
                                Se a o checkbox estiver marcado, tudo que acontece com acordo e parcela será enviado ao plecto.<br />
                                <br />
                                Enviar dados: <Switch defaultChecked={this.state.dados.enviar_dados} onChange={(checked) => { this.handleOnChange(checked) }} />

                            </div>
                        )}
                </div>
            </BaseConfig>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Configuracoes/DadosPlecto/index.js